(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
// Footer mobile collapse functionality - approach đơn giản
document.addEventListener('DOMContentLoaded', function() {
  function initFooterCollapse() {
    if (window.innerWidth <= 767) {
      const collapsibleHeadings = document.querySelectorAll('.hdt-footer-collapsible');
      
      collapsibleHeadings.forEach(function(heading) {
        const headingId = heading.getAttribute('data-footer-heading');
        const contentWrapper = document.querySelector(`[data-footer-content="${headingId}"]`);
        
        if (contentWrapper) {
          // Reset trạng thái ban đầu
          contentWrapper.style.height = '0';
          contentWrapper.classList.remove('open');
          heading.classList.remove('active');
          
          heading.addEventListener('click', function() {
            const isOpen = contentWrapper.classList.contains('open');
            
            if (isOpen) {
              // Đóng
              contentWrapper.style.height = contentWrapper.scrollHeight + 'px';
              setTimeout(() => {
                contentWrapper.style.height = '0';
              }, 10);
              contentWrapper.classList.remove('open');
              this.classList.remove('active');
            } else {
              // Mở
              contentWrapper.style.height = 'auto';
              const height = contentWrapper.scrollHeight;
              contentWrapper.style.height = '0';
              setTimeout(() => {
                contentWrapper.style.height = height + 'px';
              }, 10);
              contentWrapper.classList.add('open');
              this.classList.add('active');
              
              // Reset về auto sau animation
              setTimeout(() => {
                if (contentWrapper.classList.contains('open')) {
                  contentWrapper.style.height = 'auto';
                }
              }, 300);
            }
          });
        }
      });
    }
  }
  
  // Khởi tạo
  initFooterCollapse();
  
  // Re-init khi resize
  window.addEventListener('resize', function() {
    // Reset tất cả states
    const contentWrappers = document.querySelectorAll('.hdt-footer-content-wrapper');
    const collapsibleHeadings = document.querySelectorAll('.hdt-footer-collapsible');
    
    contentWrappers.forEach(wrapper => {
      wrapper.style.height = '';
      wrapper.classList.remove('open');
    });
    
    collapsibleHeadings.forEach(heading => {
      heading.classList.remove('active');
    });
    
    // Re-init nếu cần
    initFooterCollapse();
  });
});

  } catch(e) { console.error(e); }
})();
})();
